module.exports = __webpack_public_path__ + "img/img_034@2x.99dd3560.png";